import * as bg01 from '../actions/bg01.actions';
import * as moment from 'moment';
export interface State {
    BG01_14;
    BG01_26;
    BG01_22;
    BG01_18;
}
export const initialState = {
    BG01_14: [],
    BG01_26: [],
    BG01_22: [],
    BG01_18: []
};

export function reducer(state = initialState, action: bg01.Actions) {
  switch (action.type) {
    case bg01.GO_TO_PAGE_BG01: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        ...data
      });
    }
    default:
      return state;
  }
}

function transformResponse(data) {
  const res = data.policyEnquiry;
  const inforce_policy = res.filter(policy => policy.isInForceFlag === 'Y');
  const overdue_policy = res.filter(policy => policy.isOverdueFlag === 'Y');
  const due_policy = res.filter(policy => policy.isPolicyDueFlag === 'Y');
  const pending_policy = res.filter(policy => policy.isPendingFlag === 'Y');
  return {
    BG01_14: inforce_policy.map(policy => {
        return {
            policyNo: policy['policyNo'],
            productName: policy['productName'],
            policyNoAndPolicyOwnerNameAndProductName: policy['policyNoAndPolicyOwnerNameAndProductName']
        };
    }),
    BG01_26: overdue_policy.map(policy => {
        return {
            policyNo: policy['policyNo'],
            productName: policy['productName'],
            policyNoAndPolicyOwnerNameAndProductName: policy['policyNoAndPolicyOwnerNameAndProductName']
        };
    }),
    BG01_22: due_policy.map(policy => {
        return {
            policyNo: policy['policyNo'],
            productName: policy['productName'],
            policyNoAndPolicyOwnerNameAndProductName: policy['policyNoAndPolicyOwnerNameAndProductName']
        };
    }),
    BG01_18: pending_policy.map(policy => {
        return {
            policyNo: policy['policyNo'],
            productName: policy['productName'],
            policyNoAndPolicyOwnerNameAndProductName: policy['policyNoAndPolicyOwnerNameAndProductName']
        };
    })
  };
}
